import { twMerge } from '@shared/themes';
import { APP_DOWNLOAD_IMAGES, ROUTES } from '@shared/utils';
import Link from 'next/link';
import { ThemeAwareImage } from '../Footer/components/ThemeAwareImage';

type AppDownloadLinksProps = {
  className?: string;
};

function AppDownloadLinks({ className }: AppDownloadLinksProps) {
  return (
    <div className={twMerge('flex flex-row gap-2', className)} data-testid="app-download-buttons" data-track-container="App Stores">
      <Link href={ROUTES.FOOTER.DOWNLOAD_THE_APP.APP_STORE} data-track-name="Apple" data-testid="app-store-link">
        <ThemeAwareImage className="w-35 h-10 object-cover border border-white rounded-md" src={APP_DOWNLOAD_IMAGES.APP_STORE} alt="App Store" width={140} height={40} />
      </Link>
      <Link href={ROUTES.FOOTER.DOWNLOAD_THE_APP.GOOGLE_PLAY} data-track-name="Android" data-testid="google-play-link">
        <ThemeAwareImage className="w-35 h-10 object-cover border border-white rounded-md" src={APP_DOWNLOAD_IMAGES.GOOGLE_PLAY} alt="Google Play" width={140} height={40} />
      </Link>
    </div>
  );
}

export { AppDownloadLinks };
